import { QuillDeltaToHtmlConverter } from 'quill-delta-to-html' // this library is garbage, needs to be replaced by a custom solution (a lot of work) but should do the trick as an MVP
import { DeltaOperation } from 'quill'
import { jsPDF } from 'jspdf'

export const exportAsPdf = async (editorContent: DeltaOperation[], fileName: string): Promise<jsPDF> => {
  const pdf = new jsPDF('p', 'px', 'letter')
    
  const converter = new QuillDeltaToHtmlConverter(editorContent as DeltaOperation[])
  const html = converter.convert()

  const htmlElement = document.createElement('div')
  htmlElement.style.width = '100%'
  htmlElement.style.fontSize = '0.5em'
  htmlElement.style.display = 'block'
  htmlElement.style.padding = '30px'
  htmlElement.innerHTML = html

  pdf.html(htmlElement, {
    margin: 30,
    callback: (pdf: jsPDF) => {
      pdf.save(fileName + '.pdf')
      htmlElement.remove()
    },
    autoPaging: true,
  })

  return pdf
}